import styles from './AboutCounsel.module.scss';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import React from 'react';
import Image from 'next/image';

import dustin from '../../../../../assets/img/about/counsel/Dustin.png';
import dlynn from '../../../../../assets/img/about/counsel/DLynn.png';
import jane from '../../../../../assets/img/about/counsel/Jane.png';
import jennifer from '../../../../../assets/img/about/counsel/Jennifer.png';
import jonathan from '../../../../../assets/img/about/counsel/Jonathan.png';
import cj from '../../../../../assets/img/about/counsel/CJ.png';
import cassidy from '../../../../../assets/img/about/counsel/Cassidy.png';

export const vinovestCouncil = [
    {
        photo: jane,
        name: 'Jane Lopes',
        position: 'ADVISOR',
        description:
            "Jane is a sommelier with experience at New York's Eleven Madison Park, Nashville's The Catbird Seat, Chicago's The Violet Hour, and Melbourne's Attica. She was one of less than 30 women to ever pass the Master Sommelier exam, is a published author, and is currently developing her own import company, bringing Australian wine to the United States.",
        positionInAdvisor: 'Wine Director at Attica'
    },
    {
        photo: jennifer,
        name: 'Jennifer Grancio',
        position: 'ADVISOR',
        description:
            'Jennifer was on the founding team of BlackRock iShares, where she led P&L, partnerships, and marketing. She earned her MBA with honors from Columbia business school and her BA with honors from Stanford University.',
        positionInAdvisor: 'Advisor'
    },
    {
        photo: jonathan,
        name: 'Jonathan Ross',
        position: 'ADVISOR',
        description:
            'Born and raised in New Jersey, Jonathan has worked in New York at a number of high-profile restaurants including Eleven Madison Park as head sommelier, and as beverage director for the Rockpool Dining Group in Melbourne Australia. While down under he curated wines for Qantas Airlines and launched his own wine label, Micro Wines. Jonathan was the Guild of Sommeliers TopSomm champion in 2015, passed the Master Sommelier exam in September 2017.',
        positionInAdvisor: 'Master Sommelier'
    },
    {
        photo: dustin,
        name: 'Dustin Wilson',
        position: 'ADVISOR',
        description:
            'Dustin Wilson is a Master Sommelier and was previously Wine Director of the 3 Michelin-starred restaurant, Eleven Madison Park. This expertise led him to have a leading role in the critically acclaimed wine documentary, SOMM.',
        positionInAdvisor: 'Master Sommelier'
    },
    {
        photo: dlynn,
        name: 'DLynn Proctor',
        position: 'ADVISOR',
        description:
            'As a winery executive, DLynn has spent the last decade in global leadership roles with Penfolds Winery and Fantesca Estate & Winery, focusing on import/export, sales, marketing, strategy, and consumer relations. The previous decade of his career, DLynn was instrumental in building restaurant and training programs, restaurant and retail wine lists, and expanding new venue operations, while garnering accolades as an accomplished sommelier.',
        positionInAdvisor: 'DIRECTOR, FANTESCA ESTATE & WINERY'
    },
    {
        photo: cj,
        description:
            'CJ is the owner of McCollum Heritage 91 and a professional basketball player for the New Orleans Pelicans. As an ambassador and advisor, CJ brings several years of wine and business experience to Vinovest. As of 2022, he is also the only active NBA player to own and operate a vineyard. CJ focuses his efforts on programs to make wine investing more inclusive and equitable.',
        name: 'CJ McCollum',
        position: 'Advisor'
    },
    {
        photo: cassidy,
        description:
            'Cassidy joined the wine trade in 2003. His current role is a Global Wine Consultant for Company Fine Wine; a bespoke Napa Wine Merchant and Advisory Firm. Prior to that he was Director of Wine at Pol Roger Limited; a wine and spirits agency company. He passed his MW in 2018, completing his research paper on the rise of the Swartland Wine Region. He runs his own consultancy firm, Purple Grape and his clients include British Airways where he advises on their wine selection, and Mullineux and Leeu wines in the Swartland. He has lectured on wine at Oxford, Cambridge and Stanford Universities. Outside of wine, he enjoys travel, literature, sport and art when not spending time with his young family.',
        name: 'Cassidy Dart',
        position: 'Advisor'
    }
];

export const AboutCounsel = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <section id={'VinovestCouncil'} className={`${styles.SectionContainer}`} ref={ref}>
            <div className={styles.SectionContent}>
                <div className={`${styles.TopContentContainer} ${runAnimation}`}>
                    <h2 className={`${styles.TopTitle} ${runAnimation}`}>Vinovest Council</h2>
                    <p className={styles.TopDescription}>
                        Our talented team of experienced operators, software engineers, designers, and data scientists
                        have previously started, scaled and sold several venture-backed companies.
                    </p>
                    <ul className={styles.Team}>
                        {vinovestCouncil.map((member) => (
                            <li key={member.name}>
                                <span className={`image`}>
                                    <Image src={member.photo.src} alt={member.name} width={126} height={126} />
                                </span>
                                <span className={'name'}>{member.name}</span>
                                <span className={'position'}>{member.position}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};
